module.exports = __webpack_public_path__ + "static/media/logo-left.775b0f7b.png";